// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote___1gx_","modalFooterButton":"ModalNotes_modalFooterButton__1tZ3z"};